import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneratorEnv } from '../../web-generator/generator-env-token';
import { isPlatformBrowser } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "../../web-generator/generator-env-token";
import * as i2 from "./server-config.service";
import * as i3 from "@angular/common/http";
import * as i4 from "../../web-generator/template-generator/service/template.service";
/** ITRI 熱門關鍵字 API */
export class HotKeywordsService {
    constructor(generatorEnv, platformId, serverConfigService, http, templateService) {
        this.generatorEnv = generatorEnv;
        this.platformId = platformId;
        this.serverConfigService = serverConfigService;
        this.http = http;
        this.templateService = templateService;
        /** 取熱門關鍵字 */
        this._hotKeyWords$ = new BehaviorSubject(undefined);
        /** 查過的關鍵字 */
        this.records = [];
        /** 取查過的關鍵字 */
        this.records$ = new ReplaySubject();
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser) {
            const keywordRecords = sessionStorage.getItem('keywordRecords');
            if (keywordRecords) {
                this.records = JSON.parse(keywordRecords);
                this.records$.next(this.records);
            }
        }
        this._hotKeyWordsApi$ = this.templateService.siteInfo$.pipe(map(siteInfo => siteInfo.keywords));
    }
    get hotKeyWords$() {
        if (this.hotKeyWords) {
            return this._hotKeyWords$;
        }
        else {
            return this._hotKeyWordsApi$;
        }
    }
    /** 熱門關鍵字 */
    get hotKeyWords() {
        return this._hotKeyWords$.value;
    }
    /** 記錄我(這次拜訪網站)查過的關鍵字(，包含進網站url上帶的關鍵字) */
    record(keyword) {
        if (!this.records.find(r => r === keyword)) {
            this.records.push(keyword);
            const newRecs = JSON.parse(JSON.stringify(this.records));
            this.records$.next(newRecs);
            if (this.isBrowser) {
                sessionStorage.setItem('keywordRecords', JSON.stringify(newRecs));
            }
        }
        this.http.post(`${this.generatorEnv.apiHost}/api/site/${this.serverConfigService.config.lang}/keyword`, {}, {
            params: {
                word: keyword,
            }
        }).subscribe();
    }
}
HotKeywordsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HotKeywordsService_Factory() { return new HotKeywordsService(i0.ɵɵinject(i1.GENERATOR_ENV_TOKEN), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i2.ServerConfigService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.TemplateService)); }, token: HotKeywordsService, providedIn: "root" });
